export default __webpack_public_path__ + "static/media/menu.56245398.svg";